export enum ChatStreamEventTypeEnum {
    Status = 'status',
    TextDelta = 'text_delta',
    Error = 'error',
    Complete = 'complete',
}
